import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CHANGE_PASS_PATH, GDPR_PATH } from '@app/pcs/user/constants';
import { APPLICANT_AGENCY_TYPE, hasValue } from '@util';
import * as R from 'ramda';

const LOGIN_PATH = '/login';
export const DOSSIER_PATH = '/app/dossier/';
export const PAP_SEARCH_PATH = '/app/pap/search';
export const TIMETABLE_PATH = 'geography/timetable';
export const AGENCIES_AND_USERS_PATH = '/app/agencies-and-users';
export const USER_SETTINGS_PATH = '/app/settings';

@Injectable()
export class RedirectService {

  constructor(private router: Router, private location: Location) {
  }

  goToHome() {
    this.navigate('/');
  }

  goBack() {
    this.location.back();
  }

  goToLogin() {
    this.navigate(LOGIN_PATH);
  }

  goToGDPR() {
    this.navigate(GDPR_PATH);
  }

  goToChangePassword() {
    this.navigate(CHANGE_PASS_PATH);
  }

  goToPapSearch({
    searchType,
    dossierId = null,
    ttpId = null,
    territoryId = null,
    subPathId = null,
    timetableType = null,
    papRequestId = null
  }) {
    const queryParams = R.pickBy(hasValue, {
      dossierId,
      territoryId,
      subPathId,
      ttpId,
      timetableType,
      papRequestId
    });
    this.router.navigate([`${PAP_SEARCH_PATH}/${searchType}`], {
      queryParams
    });
  }

  goToAdvancedSearch() {
    this.navigate('/app/dashboard/advanced-search');
  }

  goToGtcAcceptance() {
    return this.router.navigate(['app/administration/acceptance-gtc']);
  }

  goToPapSelectionWizard(dossierDraftId) {
    this.router.navigate([`${DOSSIER_PATH}/pap-selection-wizard/reorder-paps`], {queryParams: {dossierDraftId}});
  }

  goToSubPathPapWizard({dossierId, territoryId, subPathId, selectedPapIds, searchType}) {
    const queryParams = hasValue(subPathId) ? {subPathId} : {};
    this.router.navigate(
      [`${DOSSIER_PATH}${dossierId}/${TIMETABLE_PATH}/${APPLICANT_AGENCY_TYPE}/insert-pap-wizard/${searchType}/${territoryId}/${selectedPapIds}/reorder-paps`],
      {queryParams}
    );
  }

  goToAlternativeOfferPreview({papRequestId, dossierId, alternativePapId}) {
    this.router.navigate([`${DOSSIER_PATH}${dossierId}/pap-requests/alternative-offer/preview`], {
      queryParams: {papRequestId, alternativePapId}
    });
  }

  goToAgenciesAndUsers() {
    this.navigate(AGENCIES_AND_USERS_PATH);
  }

  goToComments(dossierId) {
    return this.router.navigate([`${DOSSIER_PATH}${dossierId}/comments`]);
  }

  goToEditComment(dossierId) {
    return this.router.navigate([`${DOSSIER_PATH}${dossierId}/comments/edit-comment`]);
  }

  goToMakeObservation(dossierId) {
    return this.router.navigate([`${DOSSIER_PATH}${dossierId}/comments/make-observation`]);
  }

  goToUserSettings() {
    this.navigate(USER_SETTINGS_PATH);
  }

  private navigate(url) {
    this.router.navigate([url]);
  }
}
